import { AxiosInstance } from "axios"

export interface GetPayoutConfigResponse {
  apiStatus: string
  data: {
    taPriceConfigId: number
    payoutConfig: string
  }
}

export function getPayoutConfigApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/agent/payout-config",
  }) as Promise<{ data: GetPayoutConfigResponse }>
}
